import React from 'react';
import './ModeSelector.css';

export type AppMode = 'learner' | 'coach' | 'admin';

interface ModeSelectorProps {
  currentMode: AppMode | null;
  onModeChange: (mode: AppMode) => void;
  isAdmin?: boolean;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({ currentMode, onModeChange, isAdmin = false }) => {
  return (
    <div className="mode-selector">
      <h2>Choose Your Role</h2>
      <div className="mode-cards">
        <div 
          className={`mode-card ${currentMode === 'learner' ? 'active' : ''}`}
          onClick={() => onModeChange('learner')}
        >
          <div className="mode-icon">🎓</div>
          <h3>Learner</h3>
          <p>Practice speech and play games</p>
          <ul>
            <li>Free recording</li>
            <li>Voice analysis</li>
            <li>Phoneme feedback</li>
          </ul>
        </div>
        
        <div 
          className={`mode-card ${currentMode === 'coach' ? 'active' : ''}`}
          onClick={() => onModeChange('coach')}
        >
          <div className="mode-icon">🎯</div>
          <h3>Coach</h3>
          <p>Record specific sounds</p>
          <ul>
            <li>Guided prompts</li>
            <li>Audio & video recording</li>
            <li>Upload contributions</li>
          </ul>
        </div>
        
        {isAdmin && (
          <div 
            className={`mode-card ${currentMode === 'admin' ? 'active' : ''}`}
            onClick={() => onModeChange('admin')}
          >
            <div className="mode-icon">⚙️</div>
            <h3>Admin</h3>
            <p>Manage prompts, review submissions, and analyze data</p>
            <ul>
              <li>Manage sound prompts</li>
              <li>Review submissions</li>
              <li>Analytics dashboard</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModeSelector;